import React from 'react'
import PropTypes from 'prop-types'

const ActionBtn = ({ title, action, icon, btnClass }) => (

  <button type='button' className={'btn w-100 ' + (btnClass || 'btn-light')} onClick={action}>
    {icon ? <i className={icon} /> : ''}
    <span className='float-right'>{title}</span>
  </button>
)

ActionBtn.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  action: PropTypes.func.isRequired,
  btnClass: PropTypes.string
}

export default ActionBtn



// WEBPACK FOOTER //
// ./src/molecules/components/ActionBtn.js